<template>
  <div class="modal-temp">
    <div class="modal-backdrop" v-if="showModalData" @click="closeModal"></div>
    <mt-popup
      v-model="showModalData"
      position="center"
      popup-transition="popup-fade"
      :closeOnClickModal="clickfalse"
    >
      <slot name="header"></slot>
      <slot name="content"></slot>
      <slot name="footer"></slot>
    </mt-popup>
  </div>
</template>
<script>
export default {
  name: "modalTemp",
  props: {
    showModal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return { clickfalse: false, showModalData: false };
  },
  methods: {
    closeModal() {
      this.$emit("closeModal");
    }
  },
  watch: {
    showModal(val) {
      this.showModalData = val;
    }
  }
};
</script>
<style lang="less">
.modal-temp {
  .modal-backdrop {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.65);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  .v-modal {
    display: none;
  }
  .mint-popup {
    width: 72% !important;
    border-radius: 6px !important;
    letter-spacing: 1px !important;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/modal/modalTemp.vue